import { v4 as uuidv4, NIL as NIL_UUID, validate as uuidValidate } from 'uuid';

export class GuidHelper {
  static newGuid(): string {
    return uuidv4();
  }

  static empty(): string {
    return NIL_UUID;
  }

  static isGuid(value: string): boolean {
    return uuidValidate(value);
  }
}
